import { atom } from "recoil";
export const AnalyticDataFalg = atom({
    key: "AnalyticDataFalg", // unique ID (with respect to other atoms/selectors)
    default: false, // default value (aka initial value)
});
